<rpfsa-app-toolbar *ngIf="isAuthenticated$ | async" (sideNavToggle)="sideNavToggle()"></rpfsa-app-toolbar>
<mat-sidenav-container *ngIf="isAuthenticated$ | async" class="sidenav-container">
	<mat-sidenav
		#sidenav
		mode="side"
		fixedInViewport="true"
		opened
		class="pl-1 pr-1 sidenav"
	>
		<mat-nav-list fxLayout="column">
			<rpfsa-user-info></rpfsa-user-info>
			<mat-divider class="pb-2 sidenav-divider"></mat-divider>

			<h3 class="sidenav-subheader"><strong>Operations</strong></h3>
			<div *ngFor="let list of sidenavOperationsList">
				<a
					mat-list-item
					*ngIf="isAuthorizedRole(list)"
					[routerLink]="list.link"
					[routerLinkActive]="['selected-list-item']"
				>
					<mat-icon mat-list-icon>{{ list.icon }}</mat-icon>
					<h4 mat-line>{{ list.title }}</h4>
				</a>
			</div>
			<h3 class="sidenav-subheader"><strong>Administrative</strong></h3>
			<div *ngFor="let list of sidenavAdminList">
				<a
					mat-list-item
					*ngIf="isAuthorizedRole(list)"
					[routerLink]="list.link"
					[routerLinkActive]="['selected-list-item']"
				>
					<mat-icon mat-list-icon>{{ list.icon }}</mat-icon>
					<h4 mat-line>{{ list.title }}</h4>
				</a>
			</div>
		</mat-nav-list>
		<footer class="version">
			<span title="{{ currentAppVersionFull }}"
				>v{{ currentAppVersion }}</span
			>
		</footer>
	</mat-sidenav>
	<mat-sidenav-content [ngClass]="{ container: addContainer }">
		<router-outlet></router-outlet>
	</mat-sidenav-content>
</mat-sidenav-container>
